import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "close-thick"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-close-thick',
    templateUrl: './icon-close-thick.component.html',
    styleUrls: ['./icon-close-thick.component.scss'],
    standalone: false
})
export class IconCloseThickComponent   {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
